<p class="mb-4">Please select to include the following into your form.</p>

<div class="flex flex-col gap-4">
	<div class="flex flex-col gap-1">
		<mat-checkbox
			[checked]="isReminderEnabled"
			(change)="onReminderNotesToggle($event.checked)"
			color="primary"
			[disabled]="readOnly"
		>
			Reminder Notes
		</mat-checkbox>
		@if (isReminderEnabled) {
			<div class="pl-6 text-sm">
				@if (templatePreview) {
					<span class="text-grey-90">{{ templatePreview }}</span>
				} @else {
					<span class="italic text-grey-60">No details added</span>
				}
				@if (!readOnly) {
					<button
						type="button"
						class="ml-2 cursor-pointer border-0 bg-transparent p-0 text-sm text-red underline"
						(click)="openReminderNotesEditor()"
					>
						Edit
					</button>
				}
			</div>
		}
	</div>
</div>
